export default __webpack_public_path__ + "img/bc4cba0344245923a8adf65cab8f47f1.svg";